(function () {
  'use strict';

  /* @ngdoc object
   * @name alvBidding
   * @description
   *
   */
  angular
    .module('alvBidding', [
      'ui.router'
    ]);
}());
